import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AdminInterestContext from "../../context/adminInterest/adminInterestContext";
import AdminRegistrationContext from "../../context/adminRegistration/adminRegistrationContext";
import ConfirmModal from "../utilities/ConfirmModal";
import ExportPdfButton from "./ExportPdfButton";
import moment from "moment";
import * as FaIcons from "react-icons/fa";

const InterestForm = ({ formData }) => {
  const navigate = useNavigate();
  const adminInterestContext = useContext(AdminInterestContext);
  const {
    formModal,
    setFormModal,
    deleteEntrie,
    InterestNotes,
    getNotes,
    updateEntrie,
  } = adminInterestContext;
  const adminRegistrationContext = useContext(AdminRegistrationContext);
  const { transferInterestToRegistration } = adminRegistrationContext;

  const {
    _id,
    status,
    lastContactDate,
    campaign, 
    studentId,
    studentNumber,
    studentFirstName,
    studentLastName,
    gradeLevel,
    birthDate,
    age,
    parentRelationship,
    parentFirstName,
    parentLastName,
    primaryEmail,
    phone,
    street1,
    street2,
    state,
    region,
    city,
    country,
    zipCode,
    sameAddress,
    mailingStreet1,
    mailingStreet2,
    mailingCity,
    mailingState,
    mailingRegion,
    mailingCountry,
    mailingZipCode,
    learningCenterName,
    learningCenterCharter,
    learningCenterAddress,
    enrollstatus,
    brandName
  } = formData;
  

  const [showNotInterestedModal, setShowNotInterestedModal] = useState(false);

  // ADD this function
  const updateStatusAndNavigate = (navigateTo = "/interest-forms") => {
    const matchingNote = InterestNotes.find(
      (note) => note.interestId === _id
    );

    if (matchingNote) {
      const updatedData = {
        status: "Follow up Required",
        lastContactDate: new Date(),
      };
      updateEntrie(_id, updatedData);
    }

    if (navigateTo) {
      navigate(navigateTo);
    }
  };

  const handleCloseModal = () => {
    setShowNotInterestedModal(false);
  };

  const handleNotInterested = () => {
    const updatedData = {
      status: "Not Interested",
      lastContactDate: new Date(),
    };
    updateEntrie(_id, updatedData);
    navigate("/interest-forms");
  };

  useEffect(() => {
    if (_id) {
      getNotes(_id);
    }
  }, [_id]);

  // ADD this useEffect for browser back button
  useEffect(() => {
    const handleBrowserBack = () => {
      updateStatusAndNavigate(null); // Don't navigate, just update
    };

    window.addEventListener('popstate', handleBrowserBack);
    
    return () => {
      window.removeEventListener('popstate', handleBrowserBack);
      
      // Also update when component unmounts (any navigation away)
      const matchingNote = InterestNotes.find(
        (note) => note.interestId === _id
      );

      if (matchingNote) {
        const updatedData = {
          status: "Follow up Required",
          lastContactDate: new Date(),
        };
        updateEntrie(_id, updatedData);
      }
    };
  }, [_id, InterestNotes, updateEntrie]);

  const handleTransferToRegistration = () => {
    transferInterestToRegistration(formData);
    navigate("/add-registration");
  };

  const handleNewContactNote = () => {
    navigate("/contactNote", { state: { _id } });
  };
  const handleEditInterest = (_id) => {
    navigate(`/editInterestForm/${_id}`);
  };

  return (
    <>
      {formModal["deleteModal"] && (
        <ConfirmModal
          title="Delete This Entry?"
          body="Are you sure you want to delete this interest form entry"
          action={deleteEntrie(_id)}
          setModal={setFormModal}
          name="deleteModal"
          redirect="/dashboard"
          btnName="Delete"
          btnColor="l4l-red"
        />
      )}
      {status !== "Not Interested" && showNotInterestedModal && (
        <ConfirmModal
          title="Not Interested?"
          body="Are you sure you want to mark this entry as Not Interested?"
          action={handleNotInterested}
          setModal={handleCloseModal}
          name="notInterestedModal"
          redirect="/interest-forms"
          btnName="Mark as Not Interested"
          btnColor="l4l-red"
        />
      )}

      <div className="interest-form">
        <div className="top-bar">
          <div
            onClick={() => updateStatusAndNavigate()}
            className="left"
          >
            <FaIcons.FaArrowLeft className="menu-icon" />
            <span>Go Back</span>
          </div>
        </div>
        <h1 className="top-title text-center">Request Information</h1>

        <div className="btn-container">
          <div
            onClick={() => handleEditInterest(_id)}
            className="btn btn-llac-dark-green"
            style={{ marginRight: "auto" }}
          >
            Edit
          </div>

          <div
            onClick={() => handleNewContactNote()}
            className="btn btn-llac-dark-green"
          >
            New Contact Note
          </div>
          <div
            onClick={() => handleTransferToRegistration()}
            className="btn btn-llac-dark-green"
          >
            Transfer to Registration Form
          </div>
          <div
            onClick={() => setShowNotInterestedModal(true)}
            className="btn btn-llac-red"
            style={{
              backgroundColor: status === "Not Interested" ? "grey" : "red",
              color: "white",
            }}
          >
            Not interested
          </div>

          <ExportPdfButton formData={formData} />
        </div>

        <div className="sub-forms">
          {InterestNotes && InterestNotes.length > 0 && (
            <div className="sub-form">
              <h3>Contact History</h3>
              <div>
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                  <thead>
                    <tr
                      style={{
                        backgroundColor: "#537131",
                        borderBottom: "2px solid #dddddd",
                        color: "white",
                        height: "30px",
                      }}
                    >
                      <th
                        style={{
                          padding: "8px",
                          textAlign: "left",
                          width: "100px",
                        }}
                      >
                        Date
                      </th>
                      <th
                        style={{
                          padding: "8px",
                          textAlign: "left",
                          width: "150px",
                        }}
                      >
                        Updated By
                      </th>
                      <th
                        style={{
                          padding: "8px",
                          textAlign: "left",
                          width: "300px",
                        }}
                      >
                        Notes
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {InterestNotes.map((note, index) => (
                      <tr
                        key={index}
                        style={{ borderBottom: "1px solid #dddddd" }}
                      >
                        <td style={{ padding: "10px", textAlign: "left" }}>
                          {moment(note.timestamp).format("MM/DD/YYYY")}
                        </td>
                        <td style={{ padding: "10px", textAlign: "left" }}>
                          {note.Username}
                        </td>
                        <td style={{ padding: "10px", textAlign: "left" }}>
                          {note.notes}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          <div className="sub-form">
            <h3>Selected Learning Center</h3>
          
          <div className="sum-item">
              <h4>Brand Name:</h4>
              <p>{brandName}</p>
            </div>
            <div className="sum-item">
              <h4>Charter:</h4>
              <p>{learningCenterCharter}</p>
            </div>

              <div className="sum-item">
              <h4>Site/Learning Center:</h4>
              <p>{learningCenterName}</p>
            </div>

            <div className="sum-item">
              <h4>Address:</h4>
              <p>{learningCenterAddress}</p>
            </div>
            <div className="sum-item">
              <h4>Registration ID:</h4>
              <p>{formData._uuid}</p>
            </div>

            <div className="sum-item">
              <h4>campaign:</h4>
              <p>{campaign}</p>
            </div>
          </div>
          <div className="sub-form">
            <h3>
              {age >= 18 ? `${studentFirstName}'s` : "Student"} Information
            </h3>
            {studentId && (
              <div className="sum-item">
                <h4>Student ID:</h4>
                <p>{studentId}</p>
              </div>
            )}
            {studentNumber && (
              <div className="sum-item">
                <h4>Student Number:</h4>
                <p>{studentNumber}</p>
              </div>
            )}
            <div className="sum-item">
              <h4>Student's First Name:</h4>
              <p>{studentFirstName}</p>
            </div>
            <div className="sum-item">
              <h4>{studentFirstName}'s Last Name:</h4>
              <p>{studentLastName}</p>
            </div>
            <div className="sum-item">
              <h4>{studentFirstName}'s Current Age:</h4>
              <p>{`${age} - ${moment(birthDate).format("MM/DD/YYYY")}`}</p>
            </div>
            {gradeLevel && (
              <div className="sum-item">
                <h4>Grade Level:</h4>
                <p>{gradeLevel}</p>
              </div>
            )}
          </div>
          {age < 18 && (
            <div className="sub-form">
              <h3>{`${parentRelationship}'s Information`}</h3>
              <div className="sum-item">
                <h4>Your Relationship to {studentFirstName}:</h4>
                <p>{parentRelationship}</p>
              </div>
              <div className="sum-item">
                <h4>Parents First Name:</h4>
                <p>{parentFirstName}</p>
              </div>
              <div className="sum-item">
                <h4>Parents Last Name:</h4>
                <p>{parentLastName}</p>
              </div>
            </div>
          )}
          <div className="sub-form">
            <h3>
              {age >= 18 ? `${studentFirstName}'s` : `${parentRelationship}'s`}{" "}
              Contact Information
            </h3>
            <div className="sum-item">
              <h4>Email:</h4>
              <p>{primaryEmail}</p>
            </div>
            <div className="sum-item">
              <h4>Phone Number:</h4>
              <p>{phone}</p>
            </div>
          </div>
          <div className="sub-form">
            <h3>
              {age >= 18 ? `${studentFirstName}'s` : `${parentRelationship}'s`}{" "}
              Physical Address
            </h3>
            <div className="sum-item">
              <h4>Street - Line 1:</h4>
              <p>{street1}</p>
            </div>
            <div className="sum-item">
              <h4>Street - Line 2:</h4>
              <p>{street2}</p>
            </div>
            <div className="sum-item">
              <h4>Country:</h4>
              <p>{country}</p>
            </div>
            <div className="sum-item">
              <h4>Zip/Postal Code:</h4>
              <p>{zipCode}</p>
            </div>
            {country === "United States of America" ? (
              <div className="sum-item">
                <h4>State:</h4>
                <p>{state}</p>
              </div>
            ) : (
              <div className="sum-item">
                {/* <h4>Region:</h4> */}
                {/* <p>{region}</p> */}
              </div>
            )}
            <div className="sum-item">
              <h4>City:</h4>
              <p>{city}</p>
            </div>
            <div className="sum-item">
              <h4>Same as Mailing Address:</h4>
              <p>{sameAddress ? "True" : "False"}</p>
            </div>
          </div>
          {!sameAddress && (
            <div className="sub-form">
              <h3>
                {age >= 18
                  ? `${studentFirstName}'s`
                  : `${parentRelationship}'s`}{" "}
                Mailing Address
              </h3>
              <div className="sum-item">
                <h4>Street - Line 1:</h4>
                <p>{mailingStreet1}</p>
              </div>
              <div className="sum-item">
                <h4>Street - Line 2:</h4>
                <p>{mailingStreet2}</p>
              </div>
              <div className="sum-item">
                <h4>Country:</h4>
                <p>{mailingCountry}</p>
              </div>
              <div className="sum-item">
                <h4>Zip/Postal Code:</h4>
                <p>{mailingZipCode}</p>
              </div>
              {mailingCountry === "United States of America" ? (
                <div className="sum-item">
                  <h4>State:</h4>
                  <p>{mailingState}</p>
                </div>
              ) : (
                <div className="sum-item">
                  {/* <h4>Region:</h4>
                  <p>{mailingRegion}</p> */}
                </div>
              )}
              <div className="sum-item">
                <h4>City:</h4>
                <p>{mailingCity}</p>
              </div>
            </div>
          )}
        </div>
        {/* <div className="btns">
          <div
            onClick={() => {
              setFormModal("deleteModal", true);
            }}
            className="btn btn-l4l-red btn-outline"
          >
            Delete Entry
          </div>
        </div> */}
      </div>
    </>
  );
};

export default InterestForm;